import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { LangProvider } from './LangContext';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import CategoryPage from './pages/CategoryPage';
import ProductPage from './pages/ProductPage';
import ConfiguratorPage from './pages/ConfiguratorPage';
import SampleKitPage from './pages/SampleKitPage';
import ContactPage from './pages/ContactPage';
import OffertePage from './pages/OffertePage';
import LegalRoute from './pages/LegalRoute';
import NotFoundPage from './pages/NotFoundPage';
import CustomPage from './pages/CustomPage';

import { AdminAuthProvider } from './admin/AdminAuthContext';
import AdminProtectedRoute from './admin/AdminProtectedRoute';
import AdminLayout from './admin/AdminLayout';
import AdminLoginPage from './admin/AdminLoginPage';
import AdminSetupPage from './admin/AdminSetupPage';
import AdminLeadsPage from './admin/AdminLeadsPage';
import AdminDashboardPage from './admin/AdminDashboardPage';
import AdminPricesPage from './admin/AdminPricesPage';
import AdminContentPage from './admin/AdminContentPage';
import AdminMediaPage from './admin/AdminMediaPage';
import AdminSettingsEmailPage from './admin/AdminSettingsEmailPage';
import AdminSettingsSecurityPage from './admin/AdminSettingsSecurityPage';

export default function App() {
  return (
    <HelmetProvider>
      <LangProvider>
        <AdminAuthProvider>
          <BrowserRouter>
            <Routes>
              {/* Admin routes — own layout, no LangProvider chrome (Footer/NavBar). */}
              <Route path="/admin/setup" element={<AdminSetupPage />} />
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route path="/admin" element={<AdminProtectedRoute><AdminLayout /></AdminProtectedRoute>}>
                <Route index element={<AdminDashboardPage />} />
                <Route path="dashboard" element={<AdminDashboardPage />} />
                <Route path="leads" element={<AdminLeadsPage />} />
                <Route path="prices" element={<AdminPricesPage />} />
                <Route path="content" element={<AdminContentPage />} />
                <Route path="media" element={<AdminMediaPage />} />
                <Route path="settings/email" element={<AdminSettingsEmailPage />} />
                <Route path="settings/security" element={<AdminSettingsSecurityPage />} />
              </Route>

              {/* Public site */}
              <Route path="*" element={
                <Layout>
                  <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/configurator" element={<ConfiguratorPage />} />
                    <Route path="/gratis-stalen" element={<SampleKitPage />} />
                    <Route path="/offerte" element={<OffertePage />} />
                    <Route path="/contact" element={<ContactPage />} />
                    <Route path="/privacy" element={<LegalRoute kind="privacy" />} />
                    <Route path="/datenschutz" element={<LegalRoute kind="privacy" />} />
                    <Route path="/voorwaarden" element={<LegalRoute kind="terms" />} />
                    <Route path="/agb" element={<LegalRoute kind="terms" />} />
                    <Route path="/impressum" element={<LegalRoute kind="impressum" />} />
                    <Route path="/colofon" element={<LegalRoute kind="impressum" />} />
                    <Route path="/:category" element={<CategoryPage />} />
                    <Route path="/:category/:product" element={<ProductPage />} />
                    <Route path="*" element={<CustomPage fallback={<NotFoundPage />} />} />
                  </Routes>
                </Layout>
              } />
            </Routes>
          </BrowserRouter>
        </AdminAuthProvider>
      </LangProvider>
    </HelmetProvider>
  );
}
